import { useQuery } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import type { FondosContables } from '../types';

export const FONDOS_QUERY_KEY = ['contabilidad', 'fondos'] as const;

/** Qué tipos de otro trámite van a cada fondo; se configura en Configuración › Contabilidad. */
export function useFondos() {
  const { data } = useQuery<FondosContables>({
    queryKey: FONDOS_QUERY_KEY,
    queryFn: contabilidadService.getFondos,
  });

  return { fondos: data };
}
